/**
 * Hook: Submit initial setup (API + persistence + redirect) for Create Organization page.
 * Single Responsibility: call initialSetup, persist result, update Redux, toast, navigate.
 */

import { useState, useCallback } from 'react';
import { initialSetup } from '../../../services/initialSetupService';
import { fetchCurrentUser } from '../../../store/actions/authThunks';
import ROUTES from '../../../constants/routes';
import { buildInitialSetupPayload } from '../utils/buildInitialSetupPayload';
import { persistInitialSetupResult } from '../utils/persistInitialSetupResult';
import { TOAST_CONFIG, ERROR_MESSAGES, NAV_DELAY_MS } from '../constants';

export function useInitialSetupSubmit(showToast, dispatch, navigate) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitInitialSetup = useCallback(
    async (organizationData, adminData) => {
      setIsSubmitting(true);

      try {
        const payload = buildInitialSetupPayload(organizationData, adminData);
        const response = await initialSetup(payload);

        persistInitialSetupResult(response);

        await dispatch(fetchCurrentUser()).unwrap();

        showToast({
          variant: 'success',
          title: TOAST_CONFIG.TITLE_SUCCESS,
          copy: TOAST_CONFIG.SUCCESS_COPY,
        });

        setTimeout(() => {
          navigate(ROUTES.ORGANIZATION_CONFIGURATION);
        }, NAV_DELAY_MS);
      } catch (error) {
        showToast({
          variant: 'error',
          title: TOAST_CONFIG.TITLE_ERROR,
          copy: error?.message || ERROR_MESSAGES.CREATE_ORGANIZATION,
        });
        setIsSubmitting(false);
      }
    },
    [showToast, dispatch, navigate],
  );

  return { submitInitialSetup, isSubmitting };
}
